import React, { useEffect, useMemo, useState, useRef, useCallback, memo } from 'react';

// Imports from 3rd party libraries
import { withRouter } from 'react-router-dom';
import { Responsive, WidthProvider } from 'react-grid-layout';

import classNames from "classnames";

// Components import from material-ui
import { FormControl, InputLabel, Select, MenuItem, Paper, Divider, Input, IconButton } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

// Icons import from 3rd party libraries
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close"

// Imports from internal library
import { AnnotationTable } from 'dsilo-ui-components'

// Internal Components
import PDFViewerComponent from '../PDFViewer';
import PDFAnnotator from "../../components/Annonator/PDFAnnotator";
import PDFEditableTableWrapperComponent from '../PDFEditableTableViewer';
import AnnotationPdfTableViewerComponent from '../AnnotationPdfTableViewer';
import PDFExtractedDataTablesViewComponent from '../PDFExtractedTables';
import PDFQAView from '../PDFQAView';
import PDFComplexView from '../PDFComplexView'
import PDFComplexViewV2 from '../PDFComplexViewV2'
import PDFComplexViewV3 from '../PDFComplexViewV3'
import PDFComplexViewV4 from '../PDFComplexViewV4'
import PDFInvoiceGLCodes from '../PDFInvoiceGLCodes'
import PDFStepperView from '../PDFStepperView'
import StepperView from '../StepperView'
import StepperCreatedComponent from '../CreateStepperView'
import ContractFieldsSummaryView from '../ContractFieldsSummaryView'
import CognitiveSearch from '../CognitiveSearch';
import PDFWorkFlow from '../PDFWorkFlow';
import MailBox from '../MailBox/mailBoxOldWrapper';
import LayoutFilter from './LayoutFilter'
import PDFCompleteViewer from '../PDFCompleteViewer'
import DeleteDocumentViewer from '../DeleteDocumentViewer'
import TileListComponent from '../TileList';
import TileListComponentV1 from '../TileListV1';
import UploadPDFComponent from '../UploadPDFComponent';
import ListComponent from '../ListComponent';
import MiniTable from '../MiniTable';
import EditableTableComponent from '../EditableTable';
import ContractDetailsComponent from '../ContractDetails';
import LabelColorBoxSupport from '../LabelColorBoxSupport';
import ValueContainersV1Support from './../ValueContainersV1Support';
import AiModel from './../../Pages/AiBuilder/Model/index';
import ActionsComponent from '../Actions';
import ModelDetails from './../../Pages/AiBuilder/ModelDetails';
import ModelAliasNameList from '../ModelAliasNameList';
import ModelAliasNameSupporter from '../ModelAliasNameSupporter';
import OnboardingOverView from '../OnboardingOverView';
import SupplierMainInfoBox from '../OnboardingOverView/SupplierMainInfoBox';
import AdvanceDocComparison from '../AdvanceDocComparison';
import ReconciliationDashboard from "../DOMA/ReconcialiationDashboard";
import ReconciliationList from "../DOMA/ReconcialiationList";
import ObligationOverview from '../ObligationOverview'
import ObligationOverviewV2 from '../ObligationOverviewV2'
import ObligationOverviewV3 from '../ObligationOverviewV3'
import TrackerViewer from '../TrackerViewer'

import ElasticSearchWrapper from "../ElasticSearch/index";
import ElasticSearchTableComponent from "../ElasticSearchTableComponent/index";
import ElasticSearchFileComponent from "../ElasticSearchFiles/index";
import DealSheetComponent from "../DealSheetComponent/index";
import SmallOrganizationViewRedux from './../Cards/SmallOrganizationViewRedux';
import HighChart from '../../components/highcharts/Chart';
import TotalSpend from '../../components/TotalSpend';
import TopClausesComponent from '../../components/TopClauses';
import BusinessRule from 'Pages/BusinessRule';
import BusinessRules from 'Pages/BusinessRules';
import MyTasks from '../MyTasks';
import ContractViewComponent from '../ContractViewComponent';
import MyTaskListWrapper from '../MyTasks/myTaskListWrapper';
import DatapointsListWrapper from '../DataPointsList/datapointsListWrapper';
import Task from '../../components/Task';
import AliasNameList from '../AliasNameList';
import AuditTrail from '../AuditTrail';
import BulkUpload from '../BulkUpload';
import InvoiceDashboard from '../../Pages/InvoiceDashboard';
import SpendAnalyticsDashboard from '../../Pages/SpendAnalyticsDashboard';
import VendorDashboard from '../../Pages/VendorDashboard';
import ContractsInsights from '../../Pages/ContractsinsightsNew';
import DocumentHierarchy from '../DocumentHierarchy'
import WorkbookView from '../WorkbookView';
import ProcureGpt from '../ProcureGpt';
import NoAccess from '../NoAccess'

// System pages
import UserManagement from '../../Pages/UserManagement';
import AddMember from '../../Pages/UserManagement/AddMember';
import Groups from '../Groups';
import AddGroups from '../Groups/AddGroup';
import ChargeCode from '../ChargeCode';
import AddChargeCode from '../ChargeCode/AddChargeCode';
import Tickets from '../Tickets';
import AddTickets from '../Tickets/AddTickets';
import SimpleForm from '../SimpleForm/index';
import JustForm from '../JustForm/index';
import MailList from '../MailBox/index';
import MailConfig from '../MailBox/mailBox';
import Delegations from '../Delegation';
import AddDelegation from '../Delegation/AddDelegation';
import Others from '../Others';
import PowerBiComponent from '../../Pages/PowerBi';
import UserActivityPage from '../../Pages/UserActivity';
import DuplicateViewer from '../DuplicateViewer';
import PageLevelFilters from '../PageLevelFilters';
import FormulaGenerator from '../FormulaGenerator';
import DocumentViewerV2 from '../DocumentViewer'

// Dashboard components
import { ProcessDashboard1, ProcessDashboard2 } from '../ProcessDashboards';

import { Loader } from "../loader";

import Supplier from '../../images/supplier.png';

// Related to styles
import { layoutStylesGeneration } from './layoutStylesGenerator';
import { useStyles } from './styles';
import './styles.css';
import Privileges from '../../Pages/Privileges';
import AddPrivilege from '../../Pages/Privileges/AddPrivilege';
import Roles from '../../Pages/Roles';
import AddRole from '../../Pages/Roles/AddRole';
import ScheduleForm from '../Jobs/index';


import PagesDesign from '../../Pages/PagesDesign';

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const colCard = 4;

// Use const to prevent memory leaks from mutable module-level variables
const INITIAL_LAYOUT = [];
const DEFAULT_BREAKPOINT = "lg";
const MOUNTED_DEFAULT = false;
const COMPACT_TYPE_DEFAULT = "vertical";
const LAYOUT_PROPS = Object.freeze({
	className: "layout",
	rowHeight: 30,
	onLayoutChange: function () { },
	cols: { lg: 12, md: 12, sm: 12, xs: 4, xxs: 2 },
});

const LayoutBox = (props) => {

	const [breakpoint, setBreakpoint] = useState(DEFAULT_BREAKPOINT);
	const [mounted, setMounted] = useState(MOUNTED_DEFAULT);
	const [compactType, setCompactType] = useState(COMPACT_TYPE_DEFAULT);
	const [state, setState] = useState({ isFilterOn: false });
	// const [pageState, setPageState] = useState({ page: props.page });
	const [localLoading, setLocalLoading] = useState(true)
	const [searchValue, setSearchValue] = useState("");
	const [cognitiveSearchValue, setCognitiveSearchValue] = useState("");
	const [changedCognitiveSearchValue, setChangedCognitiveSearchValue] = useState(false);
	const [layout, setLayout] = useState(props.page?.layout || false);
	const [pageFilterConditions, setPageFilterConditions] = useState([]); // filter array to be sent in api call

	// Use props.page directly - avoid deep cloning which causes memory bloat
	// The page object is already managed by Redux and shouldn't be mutated
	const page = props.page;

	// Memoize layoutStyles based on layout state
	const layoutStyles = useMemo(() => layoutStylesGeneration(layout), [layout]);

	const { privilegesSupport } = props;

	useEffect(() => {
		setMounted(true);
		const timeoutId = setTimeout(() => {
			setLocalLoading(false);
			window.dispatchEvent(new Event('resize'))
		}, 1500)
		return () => {
			clearTimeout(timeoutId);
			// Reset mounted state to help with cleanup
			setMounted(false);
		}
	}, []);

	// Sync layout state when props.page.layout changes
	useEffect(() => {
		setLayout(props.page?.layout || false);
	}, [props.page?.layout]);

	useEffect(() => {
		setCompactType(props.compactType);
	}, [props.compactType])

	// Memoize callbacks to prevent ResponsiveReactGridLayout re-renders
	const onBreakpointChange = useCallback(breakpoint => {
		setBreakpoint(breakpoint);
	}, []);

	const onLayoutChange = useCallback((layout, layouts) => {
		// No-op - layout changes are handled elsewhere
	}, []);

	const onResize = useCallback((layout, oldItem, newItem, placeholder, e, element) => {
		// No-op - resize is handled elsewhere
	}, []);

	const onDrop = useCallback(elemParams => {
		// No-op - drop is handled elsewhere
	}, []);
	/**
	 * This below variable is for checking whether to display the Cognitive Search or not
	 */
	const showCognitiveSearch = useMemo(() => {
		return [
			props?.page?.chart &&
			props?.page?.chart.length > 0 &&
			props?.page?.chart?.[0].chartData?.cognitiveSearch
		].every(Boolean);
	}, [props?.page?.chart?.length, props?.page?.chart?.[0]?.chartData?.cognitiveSearch]);

	// Memoize theme check to avoid recalculation
	const isNewV1Theme = useMemo(() => props?.appConfiguration?.theme?.type === "v1.1", [props?.appConfiguration?.theme?.type]);

	let allChart = null, layouts = { lg: INITIAL_LAYOUT };
	const classes = useStyles();
	allChart = page &&
		page.chart &&
		page.chart.length > 0 &&
		page.chart.map((cData, i) => {

			let chartStyle = {
				height: cData.chartType === 'stepper'
					? 'calc(-170px + 100vh)'
					: cData.chartType === 'PDFInvoiceGLCodesView'
						? 'calc(100vh - 95px)'
						: !props.page?.title || props?.page?.hideHeader
							? page.chart.length.length === 1
								? "100%" // TODO: need to test without title
								: "100%"
							: page.chart.length.length === 1
								? '100%'
								: '100%',
				// : 'calc(100vh - 130px)',
				// height: 'calc(100vh - 130px)'
				// height: window.innerHeight < 900 ? 'calc(100vh - 95px)' : 'calc(100vh - 130px)', /// 140 is the max width of header + title 
				width: cData.chartType === "PDFInvoiceGLCodesView"
					? (props.navBarOpen
						? 'calc(100vw - 270px)'
						: 'calc(100vw - 10px)')
					: (props.hideTitle
						? "100vw"
						: (props.navBarOpen
							? isNewV1Theme ? '100%' : 'calc(100vw - 260px)'
							: 'calc(100vw - 100px)')), // 310 & 145 is with of sidebar
				overflowY: 'auto',

				// backgroundColor: '#fff'  // Only needed when configured
				...(layoutStyles.chartStyles || {}),
			}
			// Removed console.log to prevent object references from causing memory leaks
			if (layoutStyles?.chartLevelPaper) {
				chartStyle.height = window.screen.availWidth > 1700
					? 'calc(100vh - 95px)'
					: 'calc(100vh - 120px)' /// 140 is the max width of header + title
			}
			if (cData.chartType === 'powerbi' || cData.chartType === 'TILELIST' || cData.chartType === 'UserActivity') {
				chartStyle.overflowY = undefined;
				chartStyle.display = 'flex';
				chartStyle.flexDirection = 'column';
			}
			// Removed console.log to prevent object references from causing memory leaks

			return (
				<div key={i}
					// id="PageDesignerCard1-wrapper" 
					id={cData.chartUniqueId}
					style={chartStyle}>

					{/* To display the title */}
					{props.page?.title && !props.page.hideHeader && !isNewV1Theme
						&& <>
							{!props.hideTitle && (<>
								<div className={classes.titleSearchDiv}>
									<h4>{page.title}</h4>
									{showCognitiveSearch && (
										<Paper className={classNames(classes.searchRoot)}>
											<div className={classes.searchContainer}>
												<Input
													disableUnderline
													className={classes.input}
													id='standard-basic'
													label='Cognitive Search'
													variant="outlined"
													value={searchValue}
													onChange={(e) => handleSearchInput(e)}
													onKeyDown={(e) => handleKeyUp(e)}
													placeholder="Cognitive Search"
												/>
											</div>
											<IconButton
												className={classNames(classes.iconButton, classes.searchIconButton, {
													[classes.iconButtonHidden]: cognitiveSearchValue !== "",
												})}
											>
												<SearchIcon className={classes.icon} color="primary" />
											</IconButton>
											<IconButton
												onClick={() => handleCancelSearch()}
												className={classNames(classes.iconButton, {
													[classes.iconButtonHidden]: cognitiveSearchValue === "",
												})}
											>
												<CloseIcon className={classes.icon} color="primary" />
											</IconButton>
										</Paper>
									)}
									{layout && <FormControl >
										{/* <InputLabel id="layout-select-label">Layout</InputLabel> */}
										<Select
											labelId="layou-select-label"
											id="layout--select"
											value={layout}
											label="Age"
											onChange={(e) => handleLayoutChange(e)}
										>
											<MenuItem value={"layout1"}>Layout 1</MenuItem>
											<MenuItem value={"layout2"}>Layout 2</MenuItem>
											<MenuItem value={"layout3"}>Layout 3</MenuItem>
											<MenuItem value={"layout4"}>Layout 4</MenuItem>
											<MenuItem value={"layout5"}>Layout 5</MenuItem>
											<MenuItem value={"layout6"}>Layout 6</MenuItem>
										</Select>
									</FormControl>}
								</div>
								<Divider />
							</>)}
						</>
					}

					{/* externalFilters view */}
					{page && page?.externalFilter && page?.externalFilter.length && page?.selectedDataModel &&
						<PageLevelFilters
							{...props}
							chartUniqueId="pageFilterChrtUnqeId"
							externalFilters={page.externalFilter}
							filterConditions={pageFilterConditions}
							savePageFilterConditions={setPageFilterConditions}
							page={page}
						/>
					}

					{/* <Suspense fallback={<Loader />}> */}
					{(function () {
						switch (cData.chartType) {
							case 'TILELIST':
								return <TileListComponent page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} cognitiveSearchText={cognitiveSearchValue}
									changedCognitiveSearchValue={changedCognitiveSearchValue} privilegesSupport={privilegesSupport} />

							case 'TILELISTV1':
								return <TileListComponentV1 page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} cognitiveSearchText={cognitiveSearchValue}
									changedCognitiveSearchValue={changedCognitiveSearchValue} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme} />
							// all upload components
							case 'BulkUpload':
								return <BulkUpload page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'UPLOAD':
								return <UploadPDFComponent page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							// All PDF viewer components
							case 'PDFView':
								return <PDFViewerComponent page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'PDFSimpleTableView':
								return <AnnotationPdfTableViewerComponent page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'PDFTableView':
								return <PDFEditableTableWrapperComponent page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'PDFExtractedDataTablesView':
								return <PDFExtractedDataTablesViewComponent page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'annotator':
								return <PDFAnnotator page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'PDFComplexView':
								return <PDFComplexView page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'PDFComplexViewV2':
								return <PDFComplexViewV2 page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							// case 'PDFComplexViewV3':
							// 	return <PDFComplexViewV3 page={page} key={cData.chartUniqueId}
							// 		data={cData} queryString={props.queryString} appId={props.appId}
							// 		handleSideNavBarClose={props.handleSideNavBarClose} privilegesSupport={privilegesSupport} />
							case 'PDFComplexViewV3':
								return isNewV1Theme
									? <PDFComplexViewV4 page={page} key={cData.chartUniqueId}
										data={cData} queryString={props.queryString} appId={props.appId}
										handleSideNavBarClose={props.handleSideNavBarClose} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme} />
									: <PDFComplexViewV3 page={page} key={cData.chartUniqueId}
										data={cData} queryString={props.queryString} appId={props.appId}
										handleSideNavBarClose={props.handleSideNavBarClose} privilegesSupport={privilegesSupport} />
							case 'ContractFieldsSummaryView':
								return <ContractFieldsSummaryView page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'PDFQAnalystViewV2':
							case 'PDFQAnalystView':
								return <PDFQAView page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId}
									handleSideNavBarClose={props.handleSideNavBarClose} privilegesSupport={privilegesSupport} />
							case 'PDFStepperView':
								return <PDFStepperView
									page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId}
									handleSideNavBarClose={props.handleSideNavBarClose}
								privilegesSupport={privilegesSupport} />
							case 'stepper':
								return <StepperView
									page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId}
									handleSideNavBarClose={props.handleSideNavBarClose}
									privilegesSupport={privilegesSupport} />
							case 'createStepper':
								return <StepperCreatedComponent
									page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId}
									handleSideNavBarClose={props.handleSideNavBarClose}
									privilegesSupport={privilegesSupport} />
							case 'PDFInvoiceGLCodesView':
								return <PDFInvoiceGLCodes page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId}
									handleSideNavBarClose={props.handleSideNavBarClose} privilegesSupport={privilegesSupport} />
							case 'PAGESDESIGN':
								return <PagesDesign page={page} key={cData.chartUniqueId} data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							// All table viewer components
							case 'AnnotationTable':
								return <AnnotationTable page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'EditableTableView':
								return <EditableTableComponent page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'myTasks':
								return <MyTasks noDataText={'There are no tasks assigned to you'}
									page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString}
									appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'MyTaskList':
								return <MyTaskListWrapper page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString}
									appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'ContractDetails':
								return <ContractDetailsComponent page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'recentItems':
								return <MiniTable noDataText={'There are no recent items'}
									page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString}
									appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'MINITABLE':
								return <MiniTable noDataText={'There are no items display'}
									page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString}
									appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'documentViewer':
								return <DocumentViewerV2 page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'obligationViewer':
								return <ObligationOverview page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} />
							case 'obligationViewerV2':
								return <ObligationOverviewV2 page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} />
							case 'obligationViewerV3':
								return <ObligationOverviewV3 page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} />
							case 'trackerViewer':
								return <TrackerViewer page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} />
							case 'list':
								return <ListComponent page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} cognitiveSearchText={cognitiveSearchValue} pageFilterConditions={pageFilterConditions}
									changedCognitiveSearchValue={changedCognitiveSearchValue} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme} />

							case 'SchedulerForm':
								return <ScheduleForm page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} cognitiveSearchText={cognitiveSearchValue} pageFilterConditions={pageFilterConditions}
									changedCognitiveSearchValue={changedCognitiveSearchValue} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme} />

							// Datapoints UI
							case 'DataPointsList':
								return <DatapointsListWrapper page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString}
									appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'DatapointAliasNameList':
								return <AliasNameList page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							// Dashboard components
							case 'LabelColorBoxes':
								return <LabelColorBoxSupport page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} layoutStyles={layoutStyles} pageFilterConditions={pageFilterConditions} privilegesSupport={privilegesSupport} />
							case 'ValueContainersV1':
								return <ValueContainersV1Support page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							// Rules view
							case 'RULEVIEW':
								return <BusinessRule page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'RULES':
								return <BusinessRules page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'TOTALSPEND':
								return <TotalSpend page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							// Models view
							case 'MODELSLIST':
								return <AiModel page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'MODELDETAILS':
								return <ModelDetails page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'ModelAliasNameSupporter':
								return <ModelAliasNameSupporter page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'ModelAliasNameList':
								return <ModelAliasNameList page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							// Search
							case 'CognitiveSearch1':
								return <CognitiveSearch page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme} />
							case 'ELASTICSEARCH':
								return <ElasticSearchWrapper page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'ELASTICSEARCHTABLE':
								return <ElasticSearchTableComponent page={page} key={cData.chartUniqueId}
									data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'ELASTICSEARCHFILES':
								return <ElasticSearchFileComponent page={page} key={cData.chartUniqueId}
									data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							// Static components
							case 'Actions':
								return <ActionsComponent page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'ONBOARDINGOVERVIEW':
								return <OnboardingOverView page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'SUPPLIERMAININFO':
								return <SupplierMainInfoBox page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'AdvancedDocumentComparisonTable':
								return <AdvanceDocComparison page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'ReconciliationDashboard':
								return <ReconciliationDashboard page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'ReconciliationList':
								return <ReconciliationList page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							// Custom components
							case 'DEALSHEET':
								return <DealSheetComponent page={page} key={cData.chartUniqueId} data={cData}
									queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'SMALLORGANIZATIONVIEW':
								return <SmallOrganizationViewRedux page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId}
									defaultLogo={Supplier} privilegesSupport={privilegesSupport} />
							case 'TOPCLAUSES':
								return <TopClausesComponent page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId}
									defaultLogo={Supplier} privilegesSupport={privilegesSupport} />
							case 'CONTRACTVIEW':
								return <ContractViewComponent page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId}
									defaultLogo={Supplier} privilegesSupport={privilegesSupport} />
							case 'TASK':
								return <Task page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'AuditTrail':
								return <AuditTrail page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'InvoiceDashBoard':
								return <InvoiceDashboard page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'SPENDANALYTICS':
								return <SpendAnalyticsDashboard page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'VendorDashboard':
								return <VendorDashboard page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'ContractInsights':
								return <ContractsInsights page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'mailBox':
								return <MailList page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'mailBoxEdit':
								return <MailConfig page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'PDFWorkFlow':
								return <PDFWorkFlow page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} handleSideNavBarClose={props.handleSideNavBarClose} privilegesSupport={privilegesSupport} />
							case 'UserManagement':
								return props?.appConfiguration?.system?.users?.showNoAccessMessage ? (
									<NoAccess key={cData.chartUniqueId} data={cData} />
								) : <UserManagement page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'UserManagementAdd':
								return <AddMember page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme}/>
							case 'RolesList':
								return props?.appConfiguration?.system?.roles?.showNoAccessMessage ? (
									<NoAccess key={cData.chartUniqueId} data={cData} />
								) : (<Roles page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />)
							case 'RoleCreateUpdate':
								return <AddRole page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme}/>
							case 'PrivilegesList':
								return <Privileges page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'PrivilegeCreateUpdate':
								return <AddPrivilege page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme}/>
							case 'groups':
								return props?.appConfiguration?.system?.groups?.showNoAccessMessage ? (
									<NoAccess key={cData.chartUniqueId} data={cData} />
								) : (<Groups page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />)
							case 'AddGroups':
								return <AddGroups page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme}/>
							case 'ChargeCode':
								return <ChargeCode page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'AddChargeCode':
								return <AddChargeCode page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'Tickets':
								return <Tickets page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'AddTickets':
								return <AddTickets page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'PDFCompleteViewer':
								return <PDFCompleteViewer page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'DeleteDocumentViewer':
								return <DeleteDocumentViewer page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'Delegation':
								return props?.appConfiguration?.system?.delegations?.showNoAccessMessage ? (
									<NoAccess key={cData.chartUniqueId} data={cData} />
								) : (<Delegations page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />)
							case 'AddDelegation':
								return <AddDelegation page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme}/>
							case 'others':
								return props?.appConfiguration.system?.others?.showNoAccessMessage ? (
									<NoAccess key={cData.chartUniqueId} data={cData} />
								) : (<Others page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme}/>)
							case 'SimpleForm':
								return <SimpleForm page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme}/>
							case 'JustForm':
								return <JustForm page={page} key={cData.chartUniqueId}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'powerbi':
								return <PowerBiComponent page={page} appDetails={props.appDetails} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme} />
							case 'UserActivity':
								return <UserActivityPage page={page} appDetails={props.appDetails} appId={props.appId} privilegesSupport={privilegesSupport} isNewV1Theme={isNewV1Theme} />
							case 'DuplicateViewer':
								return <DuplicateViewer page={page} appDetails={props.appDetails}
									data={cData} queryString={props.queryString} appId={props.appId} privilegesSupport={privilegesSupport} />
							case 'DsiloOAIGPT': {
								if (props.hideCompleteSideNavBar) props.hideCompleteSideNavBar(true)
								return <ProcureGpt chartData={cData.chartData} page={page} hideCompleteSideNavBar={props.hideCompleteSideNavBar} chartUniqueId={cData.chartUniqueId} privilegesSupport={privilegesSupport} />
							}
							case "FormulaGenerator":
								return <FormulaGenerator page={page} appId={props.appId} privilegesSupport={privilegesSupport} />
							// All high charts
							case 'pie':
							case 'mixed':
							case 'doughnut':
							case 'bar':
							case 'stackedbar':
							case 'line':
							case 'horizontalBar':
							case 'bullet':
							case 'treemap':
								return (
									<HighChart page={props.page} key={cData.chartUniqueId}
										data={cData} queryString={props.queryString} appId={props.appId}
										layout={layout} layoutStyles={layoutStyles} pageFilterConditions={pageFilterConditions} privilegesSupport={privilegesSupport} />
								);
							case 'ProcessDashboard1':
								return (
									<ProcessDashboard1
										appId={props.appId}
										data={cData}
										key={cData.chartUniqueId}
										page={page}
									privilegesSupport={privilegesSupport} />
								);
							case 'ProcessDashboard2':
								return (
									<ProcessDashboard2
										appId={props.appId}
										data={cData}
										key={cData.chartUniqueId}
										page={page}
									privilegesSupport={privilegesSupport} />
								);
							case 'DocumentHierarchy':
								return (
									<DocumentHierarchy
										page={page}
										data={cData}
										appId={props.appId}
										key={cData.chartUniqueId}
										handleSideNavBarClose={props.handleSideNavBarClose}
										privilegesSupport={privilegesSupport}
										isNewV1Theme={isNewV1Theme}
									/>
								);
							case 'WorkbookView':
								return (
									<WorkbookView
										page={page}
										key={cData.chartUniqueId}
										data={cData} queryString={props.queryString} appId={props.appId}

										privilegesSupport={privilegesSupport} 
										isNewV1Theme={isNewV1Theme}/>
								);
							case 'NoAccess':
								return (
									<NoAccess
										data={cData}
										key={cData.chartUniqueId}
									/>
								);
							default:
								return null;
						}
					})()}
					{/* </Suspense> */}

				</div>
			);
		});
	let y = 0
	let lg = page && page.chart &&
		page.chart.length > 0 ?
		page.chart.map((element, i) => {
			y = y > element.chartData.layout.y ? y : element.chartData.layout.y + element.chartData.layout.h
			return {
				...element.chartData.layout,
				'i': "" + i,
				"moved": false,
				"static": true
			}
		}) : [];

	if (lg.length === 0) {
		lg = [{
			'x': 0, 'y': 0, w: 12, h: 2,
			'i': "enforce", "moved": false, "static": true
		}];
		allChart = <div key="enforce" align="center"
			style={{ "backgroundColor": "transparent", "borderRadius": "0px" }}>
			{"There is no layout to load"}<br />
		</div>
	} else {
		// For test
		if (allChart.length > 1) {
			lg.push({
				'x': 0, 'y': y, w: 12, h: 1,
				'i': "enforce", "moved": false, "static": true
			})
			allChart.push(<div style={{
				width: '100%',
				height: 24,
				backgroundColor: 'transparent !important',
			}} />)
		}
	}

	layouts = { lg };

	const onFilterClick = () => {
		setState({ ...state, isFilterOn: !state.isFilterOn })
	}

	/**
	 * This method is used for clearing the cognitive search text
	 */
	const handleCancelSearch = () => {
		setSearchValue("");
		setCognitiveSearchValue("");
		setChangedCognitiveSearchValue(true);
	};

	/**
	 * This is an onChange method which trigger when key is entered in the search field
	 * @param {event} e 
	 */
	const handleSearchInput = (e) => {
		const value = e?.target?.value;
		setSearchValue(value ?? "");
		if (value === "") { setCognitiveSearchValue(""); setChangedCognitiveSearchValue(true); }
	}

	/**
	 * This is triggerd when Enter key is pressed upon which the cognitive search is triggered
	 * @param {event} e 
	 */
	const handleKeyUp = (e) => {
		if (e?.keyCode === 13 || e?.key === "Enter") {
			setCognitiveSearchValue(searchValue);
			setChangedCognitiveSearchValue(true);
		} else if (e?.keyCode === 27 || e?.key === "Escape") {
			handleCancelSearch();
		}
	};

	const handleLayoutChange = (event) => {
		setLayout(event?.target?.value);
	};

	if (localLoading) {
		return <div></div>
	}

	// if (props.pageByUrlLoading) {
	// 	return <Loader />
	// }

	//TODO: `Height` needs to be calculated based on the co-ordinates of the dashboard
	// componentViewPaneElement ==> width: "100%", height: "100%"

	// console.log("layout = == = ====", layout, layoutStyles)

	return (
		<React.Fragment>
			<div
				id="componentViewPaneElement"
				style={{
					width: "100%",
					...( !isNewV1Theme ? { height: "100%" } : {} ) //for removing view page scroll bars
					// height: "calc(100vh - 150px)"
				}}>

				{allChart.length === 1
					? <>{allChart}</>
					: <>
						{allChart && <ResponsiveReactGridLayout
							style={{
								color: '#000', height: "100%",
								backgroundColor: '#fff',
								...(layoutStyles.gridLayoutStyles || {})
								// background: "#f7f7f7" // Only needed when configured
							}}
                            // {...props}
                            // {...LAYOUT_PROPS}
							className={LAYOUT_PROPS.className}
							rowHeight={LAYOUT_PROPS.rowHeight}
							cols={LAYOUT_PROPS.cols}
							layouts={layouts}
							onBreakpointChange={onBreakpointChange}
							onLayoutChange={onLayoutChange}
							onResize={onResize}
							onDrop={onDrop}
							// WidthProvider option
							measureBeforeMount={false}
							// I like to have it animate on mount. If you don't, delete `useCSSTransforms` (it's default `true`)
							// and set `measureBeforeMount={true}`.
							useCSSTransforms={mounted}
							compactType={compactType}
							preventCollision={!compactType}
							isDroppable={false}
						>
							{allChart}
						</ResponsiveReactGridLayout>}
					</>}
			</div>
		</React.Fragment>
	);
};

// Memoize LayoutBox to prevent unnecessary re-renders from parent
export default withRouter(memo(LayoutBox));
